import { createStandaloneToast } from "@chakra-ui/react"

type ErrorHandlerType = () => void

type ErrorsType = {
  [key: number]:
    | {
        [code: number]: ErrorHandlerType
      }
    | ErrorHandlerType
}

const { toast } = createStandaloneToast()

let duplicateToastIds: string[] = []

export const toastErrorMessage = (id: string, message: string) => {
  if (duplicateToastIds.includes(id)) return
  duplicateToastIds = [id, ...duplicateToastIds]

  toast({
    id,
    description: message,
    status: "error",
    duration: 3000,
    isClosable: true,
    variant: "subtle",
    position: "top",
    onCloseComplete() {
      duplicateToastIds = []
    },
  })
}

export const errorCode: ErrorsType = {
  400: {
    10001: function () {
      toastErrorMessage("400_10001", "檔案大小超過限制或服務運行中，請稍後再試")
    },
    10006: function () {
      toastErrorMessage("400_10006", "無效或錯誤的參數")
    },
    30002: function () {
      toastErrorMessage("400_30002", "無效的操作員帳號或密碼")
    },
    40001: function () {
      toastErrorMessage("400_40001", "欲更改的賽事發佈狀態與當前的一致，盤口發佈更新失敗")
    },
    40002: function () {
      toastErrorMessage("400_40002", "主表資源尚有關聯中的子表資源")
    },
    40003: function () {
      toastErrorMessage("400_40003", "賽事整合時子表ID總數只能有一個")
    },
    40004: function () {
      toastErrorMessage("400_40004", "至少需要指定兩場不同賽事ID才能整合")
    },
    40005: function () {
      toastErrorMessage("400_40005", "無法整合隊伍相反的賽事")
    },
    40006: function () {
      toastErrorMessage("400_40006", "不支持當前的數據源")
    },
    40009: function () {
      toastErrorMessage("400_40009", "檔案與原始檔案相同，請重新上傳")
    },
    40010: function () {
      toastErrorMessage("400_40010", "此賽事已存在公告")
    },
    40012: function () {
      toastErrorMessage("400_40012", "子表拆分失敗")
    },
    40013: function () {
      toastErrorMessage("400_40013", "目前該子表無法被拆分")
    },
  },
  401: {
    30000: function () {
      toastErrorMessage("401_30000", "token 已過期，請重新登入")
    },
    30001: function () {
      toastErrorMessage("401_30001", "token 有誤，請重新登入")
    },
  },
  403: {
    30005: function () {
      toastErrorMessage("403_30005", "系統維護中，請稍後再試")
    },
    30006: function () {
      toastErrorMessage("403_30006", "權限異常")
    },
  },
  404: {
    10004: function () {
      toastErrorMessage("404_10004", "目前尚未提供此服務")
    },
    30003: function () {
      toastErrorMessage("404_30003", "無此操作員或已被停用")
    },
    40000: function () {
      toastErrorMessage("404_40000", "找不到賽事")
    },
  },
  426: function () {
    toastErrorMessage("426", "版本更新，請重新整理頁面，以獲取最新資訊")
  },
  500: function () {
    toastErrorMessage("500", "伺服器異常，請稍後再試")
  },
  503: function () {
    toastErrorMessage("503", "伺服器異常，請稍後再試")
  },
}
